var render = function render(_c,_vm){return _c('div',{staticClass:"drop-down"},[_c('div',{staticClass:"drop-down__body"},[_c('div',{staticClass:"drop-down__label"},[_vm._t("label")],2),_vm._v(" "),_c('div',{staticClass:"drop-down__content"},[_vm._t("content")],2)]),_vm._v(" "),_c('div',{staticClass:"drop-down__down-content"},[_vm._t("down-content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }